import { Box, Typography } from '@mui/material'
import { aboutTimeline } from '../../data/aboutContent'
import { mobilePaddingX, mobileSectionPy } from '../../theme/mobileLayout'

export default function AboutTimelineSection() {
  return (
    <Box
      component="section"
      sx={{
        width: '100%',
        maxWidth: 1920,
        mx: 'auto',
        py: { ...mobileSectionPy, lg: '80px' },
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          px: mobilePaddingX,
          mb: { xs: 5, md: '80px' },
        }}
      >
        <Typography
          component="h2"
          sx={{
            fontSize: { xs: 22, md: 22 },
            lineHeight: 'normal',
            fontWeight: 400,
            color: '#111',
            textTransform: 'lowercase',
          }}
        >
          Our timeline
        </Typography>
      </Box>

      <Box>
        {aboutTimeline.map((item, index) => (
          <Box key={item.year}>
            <Box
              sx={{
                width: '100%',
                transition: 'background-color 0.3s ease',
                '&:hover': {
                  bgcolor: '#EBEBEB',
                  '& .timeline-year': {
                    color: '#082753',
                    fontWeight: 600,
                  },
                },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'row' },
                  alignItems: { md: 'center' },
                  gap: { xs: 3, md: '80px' },
                  px: mobilePaddingX,
                  py: { xs: 4, md: '71px' },
                  boxSizing: 'border-box',
                }}
              >
                <Typography
                  className="timeline-year"
                  sx={{
                    fontSize: { xs: 56, sm: 72, md: 88, lg: 80 },
                    lineHeight: 'normal',
                    fontWeight: 400,
                    color: '#111',
                    width: { md: 320 },
                    flexShrink: 0,
                    transition: 'color 0.3s ease',
                  }}
                >
                  {item.year}
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: 18, sm: 24, md: 30, lg: 30 },
                    lineHeight: 'normal',
                    fontWeight: 400,
                    color: '#000',
                    flex: 1,
                  }}
                >
                  {item.description}
                </Typography>
              </Box>
            </Box>
            {index < aboutTimeline.length - 1 && (
              <Box
                sx={{
                  borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                  mx: mobilePaddingX,
                }}
              />
            )}
          </Box>
        ))}
      </Box>
    </Box>
  )
}
